import React from 'react'
import * as S from './styles'

function Loader(props) {
  return (
    <S.Container {...props}>
      <S.Loader data-testid="spinner" />
    </S.Container>
  )
}
export default Loader
